import { reactive } from "vue";

import Locale from "@/helper/locale/Locale"

import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign";
import { CampaignListConfigBuilder, CampaignListFilterConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel";

export default function useCampaignListComposable(configStr) {

    const states = reactive({
        items: [],
        builder: new CampaignListConfigBuilder(),
        filterBuilder: new CampaignListFilterConfigBuilder()
    })

    const getCampaignList = function (catId) {
        states.builder.setCatId(catId)

        return new Promise((resolve, reject) => {
            BzbsCampaign.apiGetCampaign(states.builder.create(), states.filterBuilder.create()).subscribe({
                next: data => {
                    states.builder.setSkip(states.builder.campaignListConfig.defaultTopAmount + states.builder.campaignListConfig.intSkip)
                    states.items = states.items.concat(data)
                    resolve(data)
                },
                error: err => {
                    reject(err)
                }
            })
        })
    }

    states.builder.setLocale(Locale.getLocaleCode()).setConfigList(configStr)

    return {
        // states
        states,
        //methods
        getCampaignList,
    }
}
